var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('pendencies-expired',{attrs:{"moduleId":_vm.moduleId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }